export default function TarifsConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('tarifs');
    $translatePartialLoaderProvider.addPart('grilles');
}

TarifsConfiguration.$inject = ['$translatePartialLoaderProvider'];
